// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__K2F_t","imageWrapper":"styles_imageWrapper__sLzrO","loadingWrapper":"styles_loadingWrapper__xBZtN"};